export default __webpack_public_path__ + "static/media/fMveBTz2qWw.1884839b.png";